import { useCallback } from 'react';

export const useUploadAsset = ({ dataService, perfMarker, isUploadImageUpscaleEnabled }) => {
  let videoUploadPerfMarker;

  const uploadFileAsync = useCallback(({
    dataURL,
    fileObject,
    nameWithoutExt,
    updateCurrentProgress,
    isVideo,
    folderId,
    uploadCallback,
  }) => {
    if (perfMarker) {
      videoUploadPerfMarker = perfMarker.createChild('videoUpload');
      videoUploadPerfMarker.willInit();
    }

    const commonOptions = {
      updateCurrentProgress,
      name: nameWithoutExt,
      folderId,
    };

    if (isVideo) {
      return dataService.uploadVideo({
        ...commonOptions,
        fileObject,
        perfMarker: videoUploadPerfMarker,
      }).then((res) => {
        if (uploadCallback) {
          uploadCallback(res);
        }
      });
    }

    return dataService.uploadImage({
      ...commonOptions,
      imageData: dataURL,
      supportUpscale: isUploadImageUpscaleEnabled ? true : undefined,
    }).then((res) => {
      if (uploadCallback) {
        uploadCallback(res);
      }
    });
  }, [dataService, isUploadImageUpscaleEnabled, videoUploadPerfMarker]);

  return {
    uploadFileAsync,
  };
};
